import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getProductById } from '../api';
import './ProductDetailPage.css';

export default function ProductDetailPage({ onGetSolution }) {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [tab, setTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getProductById(id)
      .then(data => { setProduct(data); setLoading(false); })
      .catch(err => {
        console.error('Product detail fetch error:', err);
        setError(err?.response?.data?.message || err?.message || '加载失败');
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className="loading-center">加载中...</div>;
  if (error) return <div className="loading-center" style={{padding:60}}>
    <h2 style={{color:'#e74c3c', marginBottom:12}}>加载失败</h2>
    <p style={{color:'#666', marginBottom:20}}>{error}</p>
    <a href="/" className="btn btn-primary" style={{display:'inline-block'}}>返回首页</a>
  </div>;
  if (!product) return <div className="loading-center">产品不存在</div>;

  const advantages = Array.isArray(product.advantages) ? product.advantages : [];
  const associatedSolutions = product.associated_solutions || [];
  const cats = product.categories || [];

  const tabs = [
    { key: 'overview', label: '产品概述' },
    { key: 'advantages', label: '核心优势' },
    ...(associatedSolutions.length > 0 ? [{ key: 'solutions', label: `适配方案 (${associatedSolutions.length})` }] : []),
  ];

  return (
    <>
      <Helmet>
        <title>{product.seo_title || product.name} - 河南和正网络科技有限公司</title>
        <meta name="description" content={product.seo_description || product.summary} />
      </Helmet>

      <div className="page-banner" style={{background:'linear-gradient(135deg,#1a56db,#0d3a8e)'}}>
        <div className="container">
          <h1>{product.name}</h1>
          <nav className="breadcrumb">
            <Link to="/">首页</Link> <span>›</span>
            {cats.length > 0 ? (
              <Link to={`/category/${cats[0].id}`}>产品与技术</Link>
            ) : (
              <span>产品与技术</span>
            )} <span>›</span>
            <span>{product.name}</span>
          </nav>
        </div>
      </div>

      {/* Tab 导航 */}
      <div className="detail-tabs-bar">
        <div className="container">
          {tabs.map(t => (
            <button key={t.key} className={`detail-tab${tab === t.key ? ' active' : ''}`} onClick={() => setTab(t.key)}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <section className="section">
        <div className="container product-detail-layout">
          <div className="product-main">
            {tab === 'overview' && (
              <div className="detail-overview">
                {product.summary && <p className="product-summary">{product.summary}</p>}
                {product.tech_tags && (
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 16 }}>
                    {product.tech_tags.split(/[,;，；]/).filter(Boolean).map((tag, i) => (
                      <span key={i} className="badge badge-blue">{tag.trim()}</span>
                    ))}
                  </div>
                )}
                {(product.product_category_type || product.product_type) && (
                  <span className={`badge ${(product.product_category_type || product.product_type) === 'hardware' ? 'badge-purple' : 'badge-blue'}`} style={{marginBottom:16}}>
                    {(product.product_category_type || product.product_type) === 'hardware' ? '硬件产品' : '软件产品'}
                  </span>
                )}
                {product.overview && (
                  <div className="article-content" dangerouslySetInnerHTML={{ __html: product.overview }} />
                )}
                {product.detail_content && (
                  <div className="article-content" dangerouslySetInnerHTML={{ __html: product.detail_content }} />
                )}
              </div>
            )}

            {tab === 'advantages' && (
              <div className="advantages-list">
                {advantages.length === 0 ? (
                  <p style={{color:'var(--text-secondary)'}}>暂无核心优势描述</p>
                ) : advantages.map((adv, i) => (
                  <div key={i} className="advantage-item">
                    <div className="advantage-seq">{String(i + 1).padStart(2, '0')}</div>
                    <div>
                      <h3>{adv.title}</h3>
                      <p>{adv.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* v2.0: 产品关联的行业方案 */}
            {tab === 'solutions' && (
              <div className="product-grid">
                {associatedSolutions.map(s => (
                  <Link key={s.id} to={`/solution/${s.id}`} className="product-card">
                    <div className="product-cover">
                      {s.cover_image
                        ? <img src={s.cover_image} alt={s.name} loading="lazy" />
                        : <div className="cover-placeholder">SOLUTION</div>
                      }
                    </div>
                    <div className="product-body">
                      <h3>{s.name}</h3>
                      <p>{s.summary || '点击查看方案详情'}</p>
                      <span className="btn btn-outline btn-sm">查看方案</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <aside className="product-sidebar">
            <div className="sidebar-card">
              <h4>获取方案咨询</h4>
              <p>专业顾问为您提供定制化解决方案</p>
              <button className="btn btn-primary" style={{width:'100%',marginTop:16}} onClick={onGetSolution}>
                立即获取方案
              </button>
            </div>

            {/* 关联方案快速导航 */}
            {associatedSolutions.length > 0 && (
              <div className="sidebar-card" style={{marginTop:16}}>
                <h4 style={{marginBottom:12}}>适配行业方案</h4>
                {associatedSolutions.map(s => (
                  <Link key={s.id} to={`/solution/${s.id}`} className="product-item" style={{marginBottom:6}}>
                    <span className="product-dot" />
                    {s.name}
                  </Link>
                ))}
              </div>
            )}
          </aside>
        </div>
      </section>
    </>
  );
}
